import React, { useState, useEffect } from "react";

import { api } from "services";

import {
	isNonEmptyArray,
	isNonEmptyString,
} from "@cayuse/shared-react.utils.type-checks";

import { PersonSearchOption } from "components/flowable/FlowablePersonSearch/components/PersonSearchOption/PersonSearchOption";

import FlowableFinder from "../Common/FlowableFinder";
import usePersonSearch from "./components/hooks/usePersonSearch";

const FlowablePersonSearch = props => {
	const [ preselectedOptions, setPreselectedOptions ] = useState();
	const { search } = usePersonSearch();

	useEffect(() => {
		if (props.config.value) {
			const promises = [];

			if (isNonEmptyArray(props.config.value)) {
				props.config.value.forEach(val => {
					if (isNonEmptyString(val)) {
						promises.push(api.person.get({ id: val }));
					}
				});
			} else if (isNonEmptyString(props.config.value)) {
				promises.push(api.person.get({ id: props.config.value }));
			}

			Promise.all(promises).then(results => {
				const persons = [];

				results.forEach(data => {
					const primaryAssociation = (data.affiliations ?? []).find(
						affiliation => affiliation.primaryAppointment
					);

					persons.push({
						key: data.id,
						value: data.id,
						text: data.name,
						person: {
							personId: data.id,
							...data,
						},
						content: (
							<PersonSearchOption
								option={{
									name: data.name,
									email: data.contactEmail,
									title: primaryAssociation?.unitName,
								}}
							></PersonSearchOption>
						),
					});
				});

				setPreselectedOptions(persons);
			});
		} else {
			setPreselectedOptions(null);
		}
	}, [ props.config.value ]);

	const searchChange = selectedOptions => {
		setPreselectedOptions(selectedOptions);
		const values = isNonEmptyArray(selectedOptions)
			? selectedOptions.map(option => option.person.personId)
			: null;
		props.onChange(values);
	};

	return (
		<FlowableFinder
			search={search}
			searchChange={searchChange}
			preselectedOptions={preselectedOptions}
			key={props.config.id}
			{...props}
		/>
	);
};

export default FlowablePersonSearch;
